import React from 'react'
import { Link } from 'react-router-dom';
import blogList from './BlogData';
import categoryList from './Categories';


export default function BlogSideBar(props) {

 
  const blog = props.blog;
  const recentBlogList = [...blogList].sort((a, b) => new Date(b.displaydate) - new Date(a.displaydate)).filter(item => item !== blog).slice(0, 4);

    return (
        <>
        <div className="blog-sidebar-container position-sticky" style={{ top: "4.5rem", height: "calc(100vh - 4.5rem)", overflowY: "auto"  }}>
            <div className='recent-blog-con'>
                <div className='sidebar-blog-title'>Recent Post</div>
                {recentBlogList.slice(0, 3).map((blog, index) => (
                <div key={index} className='recent-con'>
                    <Link to={`/blog/${blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}`}>
                    <div className='row g-0'>
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                            <div className='recent-blog-img'>
                                <img src={blog.imageUrlPath} alt={blog.title}/>
                            </div>
                        </div>
                        <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                            <div className='recent-blog-text'>
                                <div className='recent-blog-title'>{blog.title}</div>
                                <div className='recent-blog-date'>{blog.displaydate.toDateString()}</div>
                            </div>
                        </div>
                    </div>
                    </Link>
                </div>
                ))}
            </div>

            <div className='cate-blog-con'>
                <div className='sidebar-blog-title'>Categories</div>
                {Object.values(categoryList).map((category, index) => (
                <div key={`category-name-${index}`} className='cate-con'>
                    <Link to={"/category/"+category.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}>
                    <div className='cate-name'>
                    {category}
                    </div>
                    </Link>
                </div>
                ))}
            </div>
        </div>
        </>
    )
};
